import React from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { Asn } from '../../../interfaces/Asn/Asn'
import { GridLpn } from '../../../components/ASN/GridLpn/GridLpnElements'

interface ASNReassignLpnModalProps {
  userReassignLpnModal: ModalReturnType<Asn>
  selectedUser: string
  setSelectedUser: React.Dispatch<React.SetStateAction<string>>
  setLpnsSelected: React.Dispatch<React.SetStateAction<string[]>>
  isErrorSelectedUser?: React.Dispatch<React.SetStateAction<boolean>>
}

export const ASNReassignLpnModal: React.FC<ASNReassignLpnModalProps> = ({
  userReassignLpnModal,
  selectedUser,
  setSelectedUser,
  setLpnsSelected,
  isErrorSelectedUser
}) => {
  return (
    <Modal
      open={userReassignLpnModal.isOpen}
      maxWidth={userReassignLpnModal.size}
      title={userReassignLpnModal.title}
      onClose={userReassignLpnModal.closeModal}
    >
      {userReassignLpnModal.extendedProps && (
        <GridLpn
          asnId={userReassignLpnModal.extendedProps.asnId}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          setLpnsSelected={setLpnsSelected}
          isErrorSelectedUser={isErrorSelectedUser}
        />
      )}
    </Modal>
  )
}

